import { ApiError, ApiErrorType } from '../types/errors';

/**
 * Map Supabase errors to our error types
 */
export function mapSupabaseError(error: any): ApiError {
  // Network error
  if (error.message?.includes('network') || 
      error.message?.includes('fetch') || 
      error.message?.includes('Failed to fetch')) {
    return {
      type: 'NETWORK_ERROR',
      message: 'ინტერნეტთან კავშირი არ არის. გთხოვთ სცადოთ ხელახლა.',
      retryable: true,
      originalError: error
    };
  }
  
  // Auth error (PGRST116 = RLS policy violation, JWT errors)
  if (error.code === 'PGRST116' || 
      error.message?.includes('JWT') ||
      error.message?.includes('auth') ||
      error.message?.includes('Unauthorized')) {
    return {
      type: 'AUTH_ERROR',
      message: 'ავტორიზაცია საჭიროა. გთხოვთ შეხვიდეთ სისტემაში.',
      retryable: false,
      originalError: error
    };
  }
  
  // Database constraint errors (23xxx = constraint violations)
  if (error.code?.startsWith('23')) {
    return {
      type: 'DATABASE_ERROR',
      message: 'მონაცემთა ბაზის შეცდომა.',
      code: error.code,
      retryable: false,
      originalError: error
    };
  }
  
  // Not found error
  if (error.code === 'PGRST116' && error.message?.includes('not found')) {
    return {
      type: 'NOT_FOUND_ERROR',
      message: 'მოთხოვნილი რესურსი არ მოიძებნა.',
      retryable: false,
      originalError: error
    };
  }
  
  // Validation error
  if (error.code === 'PGRST117' || error.message?.includes('validation')) {
    return {
      type: 'VALIDATION_ERROR',
      message: 'მონაცემები არასწორია. გთხოვთ შეამოწმოთ შეყვანილი ინფორმაცია.',
      retryable: false,
      originalError: error
    };
  }
  
  // Default unknown error
  return {
    type: 'UNKNOWN_ERROR',
    message: error.message || 'მოხდა შეცდომა.',
    retryable: true,
    originalError: error
  };
}

/**
 * Get user-friendly message for error
 */
export function getUserFriendlyMessage(error: ApiError): string {
  return error.message;
}

/**
 * Check if error is retryable
 */
export function isRetryableError(error: unknown): boolean {
  if (error && typeof error === 'object' && 'retryable' in error) {
    return (error as ApiError).retryable;
  }
  return true; // Default to retryable
}

/**
 * Get error type
 */
export function getErrorType(error: unknown): ApiErrorType {
  if (error && typeof error === 'object' && 'type' in error) {
    return (error as ApiError).type;
  }
  return 'UNKNOWN_ERROR';
}
